export const lpad = (s, c, n) => {
  if (typeof s === 'number') {
    s = s.toString();
  } else if (! s || ! c || s.length >= n) {
      return s;
  }
  const max = (n - s.length)/c.length;
  for (let i = 0; i < max; i++) {
      s = c + s;
  }
  return s;
}

export const minutesToHHMM = (minutes, noDelimeter) => {
  let minus = false;
  if (minutes < 0) {
    minus = true
    minutes = 0-minutes
  }
  return (minus ? '-' : '') + lpad(Math.floor(minutes/60),'0',2) + (noDelimeter ? "" : ":") + lpad(minutes%60,'0',2)
}

export const dateToMonthDay = (str) => {
  return `${str.substring(4,6)}/${str.substring(6,8)}`
}

export const yyyymmdd = (date) => {
  let yyyy = date.getFullYear();
  let mm = date.getMonth()+1; // getMonth() is zero-based
  let dd  = date.getDate();
  return String(10000*yyyy + 100*mm + dd); // Leading zeros for mm and dd
}

export const yyyymmddToDate = (yyyymmdd) => {
  let year = yyyymmdd.substring(0,4);
  let month = yyyymmdd.substring(4,6);
  let day = yyyymmdd.substring(6,8);
  return new Date(year, month-1, day);
}

export const getDiffMinutesForMoment = (before, after) => {
  const beforeTime = before.startOf('minute');
  const afterTime = after.startOf('minute');
  return afterTime.diff(beforeTime, 'minutes');
}

export const convertHHmmToMinutes = (input) => {
  return parseInt(input.substring(0,2),10) * 60 + parseInt(input.substring(3,5),10)
}



// WEBPACK FOOTER //
// ./src/utils/date.js